class PrintLocationBarcodesController {
    /*@ngInject*/
    constructor($state, $stateParams, $translate) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.model = {
            selectedLocations: [],
            barcodeOptions:
            {
                format: 'CODE128', lineColor: '#030303', width: 3.7, height: 80, displayValue: true,
                font: 'monospace', textAlign: 'center', textPosition: 'bottom', textMargin: 0, fontSize: 20,
                marginTop: 0, marginBottom: 0
            }
        }
    }

    $onInit() {
        let printData = undefined;
        if (window.opener && window.opener.w && window.opener.w.printData) {
            printData = window.opener.w.printData;
            this.model.selectedLocations = printData.selectedLocations;
            setTimeout(() => {
                window.print();
            }, 1500)
        }
    }
}

export default PrintLocationBarcodesController;


// WEBPACK FOOTER //
// ./client/app/components/location/print/print_location_barcodes.controller.js